<template>
  <div @click="$router.push({path: link, force: true})" class="card d-flex flex-row align-items-center justify-content-center" style="margin: 0px 20px">
      <img
      class="img"
        v-lazy="photo"
      />
      <div class="info">
        <span class="title-card">{{ title && title != 'null' ? (title.length > 30 ? title.substring(0,30)+'...': title ) : 'Passatempo'}}</span><br />
        <span class="descricao-card">{{description && description != null ?  description.length > 50 ? description.substring(0, 50)+'...' : description : 'Jogue agora mesmo!'}} </span><br/>
      </div>
    </div>
</template>
<script>
export default {
  name: "CardMin",
  props:{
    title: String,
    photo: String, 
    description: String,
    link: String,
  }
};
</script>
<style scoped>
.title {
  background-color: rgb(54, 54, 54);
  color: white;
  text-transform: uppercase;
  letter-spacing: 2px;
  text-align: center;
  padding: 5px 0px;
}

.info {
    letter-spacing: 2px;
    align-self: flex-start;
    margin-top: 10px;
    line-height: 18px;
}
.card img {
  height: 100%;
  object-fit: contain;
}

.card {
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: ease 1s;
  height: 14vh;
}

.card:hover{
  transform: scale(1.1);
}

.title-card {
  font-size: 18px;
  word-break: break-word;
  margin-top: 15px;
  font-weight: 1000;

}

.date-card {
  font-size: 14px;
  word-break: break-word;
    line-height: 12px;
    font-weight: 1000;

}

.descricao-card {
  font-size: 14px !important;
  margin-top: 5px;
  font-weight: lighter !important;
  word-break: break-word;
  letter-spacing: 0px;
  line-height: 12px;
  opacity: .7;

}

.descricao-card span{
  font-family: 'Agency FB Regular';
}
</style>